import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];
const VIEWPORT = { once: true, margin: "-70px" };
const VISIBLE = { opacity: 1, y: 0 };

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={VISIBLE}
    viewport={VIEWPORT}
    transition={{ duration: 0.85, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="eyebrow flex items-center gap-3">
    <span className="inline-block h-px w-8 bg-[#B85328]" />
    {children}
  </p>
);
